<template>
  <!--  <form class="search-field">-->
  <ais-instant-search v-if="searchClient" v-click-outside="vcoConfig" :search-client="searchClient"
                      :index-name="brandIndex">
    <ais-configure :hits-per-page.camel="7" />
    <ais-search-box
      v-model="query" placeholder="Search" />
    <div v-if="query !== ''" class="search-results grid-12">
      <ais-index :index-name="brandIndex" class="span-5 col-2 span-12-sm">
        <ais-configure :hits-per-page.camel="7" filters="is_published:true" />
        <h4 class="uppercase font-size-12 mb-15">brands</h4>
        <ais-state-results>
          <div v-show="!hits.length" slot-scope="{ results: { hits } }">No brand results found</div>
        </ais-state-results>
        <ais-hits>
          <template slot="item" slot-scope="{ item }">
            <router-link
              :to="{
                name: 'brand-bio',
                params: {
                  brandUrl: item.vanity_url_name,
                },
              }"
              class="search-suggestion"
              @click.native="query = ''"
            >
              <ais-highlight :hit="item" attribute="brand_name" />
            </router-link>
          </template>
        </ais-hits>
      </ais-index>
      <ais-index :index-name="productIndex" class="span-5 span-12-sm">
        <ais-configure
          :hits-per-page.camel="6"
          :facet-filters.camel="productFilters"
          filters="brand.is_published:true"
          clickAnalytics="true"
        />

        <h4 class="uppercase font-size-12 mb-15 mt-15-sm">products</h4>
        <ais-state-results>
          <div v-show="!hits.length" slot-scope="{ results: { hits } }">No product results found</div>
        </ais-state-results>
        <ais-hits>
          <template slot="item" slot-scope="{ item }">
            <router-link
              :to="{
                name: 'productDetails',
                params: {
                  productName: item.name,
                  productId: item.id,
                },
              }"
              class="search-suggestion"
              @click.native="handleProductClick(item)"
            >
              <div class="image-wrapper relative">
                <loader-static class="loader-current-color" />
                <image-with-fallback
                  v-if="item.image"
                  class="image"
                  :src="$utils.getCDNURL({ src: item.image, h: 150, w: 120, q: 100 })"
                  alt=""
                />
                <div v-else class="image icon-upload-image gray-bg" />
              </div>
              <div class="flex-grow-0 flex-shrink-1">
                <ais-highlight :hit="item" attribute="name" />
                <div class="mt-5 h4">${{ item.pos_price.toFixed(2) }}</div>
              </div>
            </router-link>
          </template>
        </ais-hits>
      </ais-index>
      <div class="w-100 span-12-sm hide flex-sm justify-center mt-15">
        <button class="button button-black" @click="gotoSearchFor(query)">Search For "{{ query }}"</button>
      </div>
    </div>
  </ais-instant-search>
</template>
<script>
import algoliaSearch from "algoliasearch/lite";
import vClickOutside from "v-click-outside";
import trackEvent from "@/services/tracking";
import { RouterPath } from "../../services/utils";

export default {
  name: "TheSearchField",
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      vcoConfig: {
        handler: () => {
          this.query = "";
        }
      },
      query: "",
      hits: {},

      searchClient: algoliaSearch(this.$env.algolia().appId, this.$env.algolia().token),
      productFilters: [["visible:true"], ["active:true"]]
    };
  },
  computed: {
    brandIndex: function() {
      return `${this.$env.getOrigin()}_brands`;
    },
    productIndex: function() {
      return `${this.$env.getOrigin()}_products`;
    }
  },
  watch: {
    query: function() {
      this.$store.dispatch("navigation/setDropdownType", "closed");
    }
  },
  mounted() {
    whenSearchBoxIsReady(this.addRedirectToFormSubmit);
  },
  methods: {
    gotoSearchFor(query) {
      this.$router.push(`/${RouterPath.DEFAULT_SEARCH_PRODUCT_PAGE}?keyword=${encodeURIComponent(query)}`);
    },
    handleProductClick(item) {
      this.clearSearchQuery();
      this.storeSearchQueryData(item);
      trackEvent("Autocomplete;Product Clicked", {
        objectID: item.id,
        index: this.productIndex
      });
    },
    clearSearchQuery() {
      this.query = "";
    },
    storeSearchQueryData(item) {
      this.$trackingStore.commit("setIndexName", this.productIndex);
      this.$trackingStore.commit("setQueryId", item.__queryID);
      this.$trackingStore.commit("setSource", "autocomplete");
    },
    addRedirectToFormSubmit() {
      const form = document.getElementsByClassName("ais-SearchBox-form");
      form[0].addEventListener("submit", () => {
        if (this.query !== "") {
          this.gotoSearchFor(this.query);
          this.query = "";
        }
      });
    }
  }
};

function whenSearchBoxIsReady(callback) {
  let count = 0;
  const form = document.getElementsByClassName("ais-SearchBox-form"),
    int = setInterval((iii) => {
      count++;
      if (form.length > 0) {
        clearInterval(int);
        callback();
      }
      // a 5 second timeout based on 200ms to break the loop
      if (count > 25) {
        clearInterval(int);
        this.$bugsnagClient.notify(new Error("Algolia Searchbar Widget Failed to Load"));
      }
    }, 200);
}
</script>

<style lang="scss">
.ais-InstantSearch {
  width: 100%;
}

.ais-SearchBox-form {
  width: 100%;
  height: 40px;
  position: relative;
  background: #f3f3f3;
  border-radius: 20px !important;
  border: 1px solid black;
  display: flex;

  &:focus-within {
    border: 1px solid #e1ffa1;

    .ais-SearchBox-submit {
      svg {
        display: none;
      }

      background: black url("~@/assets/img/icons/icon_search-20-white.svg") no-repeat center;
      background-size: 20px 20px;
    }
  }

  .ais-SearchBox-input {
    padding-left: 20px;
    text-transform: capitalize;
    width: calc(100% - 56px);
    height: 38px;
    background: #f3f3f3;
    border-top-left-radius: 20px !important;
    border-bottom-left-radius: 20px !important;
    padding-right: 56px + 14px;
    border: none;
  }

  .ais-SearchBox-submit {
    height: 38px;
    width: 56px;
    border-bottom-right-radius: 20px !important;
    border-top-right-radius: 20px !important;
    border: none;
    transition: background-color 0.2s ease-out;

    svg {
      display: none;
    }

    background: #f3f3f3 url("~@/assets/img/icons/icon_search-20.svg") no-repeat center;
    background-size: 20px 20px;

    &:hover {
      cursor: pointer;
      background-color: #e1ffa1 !important;

      .icon-search {
        background: url("~@/assets/img/icons/icon_search-20.svg") no-repeat center;
      }
    }
  }

  .ais-SearchBox-reset {
    position: absolute;
    right: 55px;
    margin-top: 3px;
    margin-right: 8px;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    border: none;

    &:hover {
      cursor: pointer;
      border: none;
      background-color: #e6e6e6;
    }
  }
}

.search-results {
  width: 100%;
  position: absolute;
  top: 50px;
  border: 1px solid black;
  z-index: 9999;
  background: #fbf9f9;
  padding: 20px;
}

input:placeholder-shown + .search-actions > .close-button {
  display: none;
}

.search-suggestion {
  display: flex;
  align-items: end;
  padding: 6px 0;
  position: relative;
  overflow: visible;

  &.focus {
    opacity: 0.4;
  }

  .loader-wrapper.loader-static {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 0.6);

    .loader {
      position: absolute;
      top: calc(50% - 10px);
      left: calc(50% - 10px);
    }
  }

  .loader-wrapper {
    z-index: -1;
  }

  .image-wrapper {
    margin-right: 20px;
    width: 60px;
    height: 75px;
    border: 1px solid #ccc;
  }

  .image {
    width: 60px;
    height: 75px;
    width: 100%;
    background-size: 30px !important;
  }

  .loader-wrapper {
    z-index: -1;
  }

  em {
    font-weight: 600;
  }

  &:hover {
    opacity: 0.6;
  }
}

//.router-link-active {
//  background: none!important;
//}
</style>
